import { useState } from 'react';

import { HistoryEvent } from '../../../../services/eventingApi';
import BackfillTab from './backfill/BackfillTab';
import ConfigTab from './config/ConfigTab';
import EventDrawer from './events/EventDrawer';
import EventsTab from './events/EventsTab';
import { HistoryWindow } from './events/history';
import ReplayModal from './events/ReplayModal';
import { useReplay } from './events/useReplay';
import { TabSlug } from './EventPlatformTabs';
import { TopologyResource } from './hooks/useTopology';
import OutboxTab from './outbox/OutboxTab';
import OverviewTab from './overview/OverviewTab';
import QueuesTab from './queues/QueuesTab';

interface EventPlatformContentProps {
  active: TabSlug;
  topology: TopologyResource;
  onSelect: (slug: TabSlug) => void;
}

const EventPlatformContent = ({ active, topology, onSelect }: EventPlatformContentProps) => {
  const [opened, setOpened] = useState<{ event: HistoryEvent; window: HistoryWindow } | null>(null);
  const [focusConsumer, setFocusConsumer] = useState<string | null>(null);
  const replay = useReplay();
  const data = topology.data;
  const subscriptions = data?.subscriptions ?? [];

  const openConsumer = (consumer: string) => {
    setFocusConsumer(consumer);
    onSelect('filas');
  };

  return (
    <>
      {active === 'eventos' && (
        <EventsTab onOpen={(event, window) => setOpened({ event, window })} onReplay={(events, window) => replay.setRequest({ events, window })} />
      )}
      {data && active === 'visao-geral' && <OverviewTab topology={data} onOpenConsumer={openConsumer} />}
      {data && active === 'outbox' && <OutboxTab services={data.outbox} />}
      {data && active === 'filas' && <QueuesTab focusConsumer={focusConsumer} onChanged={topology.reload} />}
      {data && active === 'backfill' && <BackfillTab subscriptions={subscriptions} />}
      {data && active === 'configuracao' && <ConfigTab topology={topology} />}

      <EventDrawer
        event={opened?.event ?? null}
        onClose={() => setOpened(null)}
        onReplay={(event) => opened && replay.setRequest({ events: [event], window: opened.window })}
      />
      <ReplayModal request={replay.request} subscriptions={subscriptions} submitting={replay.submitting} onClose={() => replay.setRequest(null)} onConfirm={replay.confirm} />
    </>
  );
};

export default EventPlatformContent;
